import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { getToken } from '../login/login.saga';
import assignmentPresetsActions, { types } from './assignmentPresets.actions';
import { SaveAssignmentPresetPayload } from './assignmentPresets.types';

interface CreateAction { type: string; accountId: string; payload: SaveAssignmentPresetPayload; }
interface UpdateAction { type: string; accountId: string; id: string; payload: SaveAssignmentPresetPayload; }
interface DeleteAction { type: string; accountId: string; id: string; }
interface FetchAction { type: string; accountId: string; }

function* createPreset({ accountId, payload }: CreateAction) {
    try {
        const token: string = yield call(getToken, accountId);
        const { data } = yield axios.post(`/api/pro/assignment-preset`, payload, { headers: { Authorization: `Bearer ${token}` } });
        yield put(assignmentPresetsActions.savePresetDone(data?.id));
        yield put(assignmentPresetsActions.fetchPresets(accountId));
    } catch (e: any) {
        if (e?.response?.status === 409) yield put(assignmentPresetsActions.savePresetConflict());
        else yield put(assignmentPresetsActions.savePresetError());
    }
}

function* updatePreset({ accountId, id, payload }: UpdateAction) {
    try {
        const token: string = yield call(getToken, accountId);
        const { data } = yield axios.put(`/api/pro/assignment-preset/${id}`, payload, { headers: { Authorization: `Bearer ${token}` } });
        yield put(assignmentPresetsActions.savePresetDone(data?.id));
        yield put(assignmentPresetsActions.fetchPresets(accountId));
    } catch (e: any) {
        if (e?.response?.status === 409) yield put(assignmentPresetsActions.savePresetConflict());
        else yield put(assignmentPresetsActions.savePresetError());
    }
}

function* deletePreset({ accountId, id }: DeleteAction) {
    try {
        const token: string = yield call(getToken, accountId);
        yield axios.delete(`/api/pro/assignment-preset/${id}`, { headers: { Authorization: `Bearer ${token}` } });
        yield put(assignmentPresetsActions.savePresetDone(undefined));
        yield put(assignmentPresetsActions.fetchPresets(accountId));
    } catch (e) {
        yield put(assignmentPresetsActions.savePresetError());
    }
}

function* fetchPresets({ accountId }: FetchAction) {
    try {
        const token: string = yield call(getToken, accountId);
        const { data } = yield axios.get(`/api/pro/assignment-preset`, { headers: { Authorization: `Bearer ${token}` } });
        yield put(assignmentPresetsActions.presetsReceived(accountId, data));
    } catch (e) {
        // Presets are non-critical for the surrounding flow; leave any previously loaded list intact.
        console.log(e);
    }
}

export function* assignmentPresetsSaga() {
    yield takeLatest(types.CREATE_PRESET, createPreset);
    yield takeLatest(types.UPDATE_PRESET, updatePreset);
    yield takeLatest(types.DELETE_PRESET, deletePreset);
    yield takeEvery(types.FETCH_PRESETS, fetchPresets);
}
